export default "__VITE_ASSET__8epfLuZN__"